import { CAURL } from "./CAURL";
import ProtectedRoutes from "../ProtectedRoutes";
import CAPageWrapper from "../../components/page_wrappers/CAPageWrapper";

import CADashboard from "../../pages/ca_pages/CADashboard";
import CAAllClientsManagementPage from "../../pages/ca_pages/clients/CAAllClientsManagementPage";
import CAAllInvoicesPage from "../../pages/ca_pages/clients/CAAllInvoicesPage";
import CAClientInvoiceEdit from "../../pages/ca_pages/clients/models/invoice_model/CAClientInvoiceEdit";
import CANotificationsPage from "../../pages/ca_pages/clients/CANotificationsPage";
import CASettingsPage from "../../pages/ca_pages/CASettingsPage";

// Teams components
import CATeamsDashboard from "../../pages/ca_pages/teams/CATeamsDashboard";
import CATeamsPage from "../../pages/ca_pages/teams/CATeamsPage";
import EmployeePage from "../../pages/ca_pages/teams/EmployeePage";
import CATasksPage from "../../pages/ca_pages/teams/CATasksPage";
import CATeamsCalendar from "../../pages/ca_pages/teams/CATeamsCalendar";
import CATeamsActivity from "../../pages/ca_pages/teams/CATeamsActivity";

// Firms Components
import CAFirmDashboard from "../../pages/ca_pages/firms/CAFirmDashboard";
import CADepartments from "../../pages/ca_pages/firms/CADepartments";
import CAOfficesDashboard from "../../pages/ca_pages/firms/CAOfficesDashboard";
import CARolesPermissionsDashboard from "../../pages/ca_pages/firms/CARolesPermissionsDashboard";

// Finance Components
import CAFinanceDashboard from "../../pages/ca_pages/finances/CAFinanceDashboard";
import BooksAndLedgers from "../../pages/ca_pages/finances/BooksAndLedgers";
import JournalEntries from "../../pages/ca_pages/finances/JournalEntries";
import Vouchers from "../../pages/ca_pages/finances/Vouchers";
import ClientPaymentsPage from "../../pages/ca_pages/finances/client_payment_request/ClientPaymentsPage";
import AllClientPaymentsRequestsPage from "../../pages/ca_pages/finances/client_payment_request/AllClientPaymentsRequestsPage";
import EditClientPaymentsPage from "../../pages/ca_pages/finances/client_payment_request/EditClientPaymentsPage";
import FirmEarningsPage from "../../pages/ca_pages/finances/FirmEarningsPage";

const routeConfigs = [
    // { path: CAURL.CA_DASHBOARD, component: CADashboard, protected: true },
    { path: CAURL.CA_DASHBOARD,                component: CADashboard },
    { path: CAURL.CA_ALL_CLIENTS,              component: CAAllClientsManagementPage },
    { path: CAURL.CA_ALL_CLIENTS_INVOICES,     component: CAAllInvoicesPage },
    { path: CAURL.CA_CLIENTS_INVOICE_EDIT,     component: CAClientInvoiceEdit },
    { path: CAURL.CA_NOTIFICATIONS_MANAGEMENT, component: CANotificationsPage },
    { path: CAURL.CA_SETTINGS,                 component: CASettingsPage },

    // teams urls
    { path: CAURL.CA_TEAMS_DASHBOARD, component: CATeamsDashboard },
    { path: CAURL.CA_ALL_TEAMS, component: CATeamsPage },
    { path: CAURL.CA_TEAMS_EMPLOYEES, component: EmployeePage },
    { path: CAURL.CA_TEAMS_TASKS,     component: CATasksPage },
    { path: CAURL.CA_TEAMS_CALENDAR,  component: CATeamsCalendar },
    { path: CAURL.CA_TEAMS_ACTIVITY,  component: CATeamsActivity },

    // firms urls
    { path: CAURL.CA_FIRM_OVERVIEW,    component: CAFirmDashboard },
    { path: CAURL.CA_FIRM_DEPARTMENTS, component: CADepartments },
    { path: CAURL.CA_FIRM_OFFICES,     component: CAOfficesDashboard },
    { path: CAURL.CA_FIRM_ROLES,       component: CARolesPermissionsDashboard },

    // finance urls
    { path: CAURL.CA_FINANCE_DASHBOARD,            component: CAFinanceDashboard },
    { path: CAURL.CA_FINANCE_BOOKS_LEDGERS,        component: BooksAndLedgers },
    { path: CAURL.CA_FINANCE_JOURNAL_ENTRIES,      component: JournalEntries },
    { path: CAURL.CA_FINANCE_VOUCHERS,             component: Vouchers },
    { path: CAURL.CA_FINANCE_CLIENT_PAYMENTS_PAGE, component: ClientPaymentsPage },
    { path: CAURL.CA_FINANCE_SHOW_ALL_CLIENT_PAYMENT_REQUESTS_PAGE, component: AllClientPaymentsRequestsPage },
    { path: CAURL.CA_FINANCE_EDIT_CLIENT_PAYMENTS_PAGE, component: EditClientPaymentsPage },
    { path: CAURL.CA_FINANCE_FIRM_EARNINGS,        component: FirmEarningsPage },
];

const CARoutes = routeConfigs.map(
    route => ({
        path: route.path,
        // element: route.protected
        // ? (
        //     <ProtectedRoutes>
        //         <CAPageWrapper>
        //             <route.component />
        //         </CAPageWrapper>
        //     </ProtectedRoutes>
        // ) : (
        //     <route.component />
        // )
        element: (
            <ProtectedRoutes>
                <CAPageWrapper>
                    <route.component />
                </CAPageWrapper>
            </ProtectedRoutes>
        )
    })
);

export default CARoutes;
